// extracted by mini-css-extract-plugin
module.exports = {"goalsModal":"_2HVmhtbYgBotYBSVMioFk3","goalsStyle":"NJHCeZQSeCmoaJUQQ2zkl"};